export default __webpack_public_path__ + "static/media/RICERCARE_IMPRESE.2776aa5e.png";